import { z } from 'zod';
import { startSessionAction } from '@/actions/run/StartSessionAction.ts';

const startSessionValueSchema = z.object({
    showTrialWarning: z.boolean(),
});

export const startSessionHandler = async (rawValue: object) => {
    const value = startSessionValueSchema.parse(rawValue);

    await startSessionAction(value.showTrialWarning);
};
